export const FETCH_SQUIRREL_NEWS_REQUEST = 'FETCH_SQUIRREL_NEWS_REQUEST';
export const FETCH_SQUIRREL_NEWS_SUCCESS = 'FETCH_SQUIRREL_NEWS_SUCCESS';
export const FETCH_SQUIRREL_NEWS_FAILURE = 'FETCH_SQUIRREL_NEWS_FAILURE';
